module.exports = __webpack_public_path__ + "static/media/Cherbourg.ed2c8cdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/council_logos/Cherbourg.png
// module id = 613
// module chunks = 0